module.exports = __webpack_public_path__ + "img/img18.f9b28b0f.svg";